import {
  GoalsHeadersContainer,
  GoalsHeaderTitle,
} from './style/GoalsRowHeader.styled';
import {
  Drafts16Regular as DraftsIcon,
  CheckmarkCircle16Regular as CheckmarkCircleIcon,
  ArrowSync16Filled as ArrowSyncIcon,
  Flag20Regular as FlagIcon,
} from '@fluentui/react-icons';
import { appearance } from 'src/hooks/useAlertMessage';
import { Alert } from 'src/components/common/AlertMessage/AlertMessage';

interface GoalRowHeaderProps {
  requestStatusMessage: string;
  requestStatusAppearance: appearance;
  hideAlert: () => void;
}

export const GoalsRowHeader = ({
  requestStatusMessage,
  requestStatusAppearance,
  hideAlert,
}: GoalRowHeaderProps) => {
  return (
    <GoalsHeadersContainer fullWidth={requestStatusMessage.length > 0}>
      {requestStatusMessage ? (
        <Alert
          requestStatusMessage={requestStatusMessage}
          requestStatusAppearance={requestStatusAppearance}
          handleClose={hideAlert}
        />
      ) : (
        <>
          <GoalsHeaderTitle>
            <DraftsIcon />
            Draft
          </GoalsHeaderTitle>
          <GoalsHeaderTitle>
            <CheckmarkCircleIcon />
            Approved
          </GoalsHeaderTitle>
          <GoalsHeaderTitle>
            <ArrowSyncIcon />
            In progress
          </GoalsHeaderTitle>

          <GoalsHeaderTitle>
            <FlagIcon />
            Closed
          </GoalsHeaderTitle>
        </>
      )}
    </GoalsHeadersContainer>
  );
};
